module.exports = __webpack_public_path__ + "img/youbian.9e93eba1.svg";